import React from 'react';
import Login from 'containers/Authentication/Login/Water';

const WaterLogin = () => <Login view="page" />;

export default WaterLogin;
